import { Icon, Tooltip } from '~/components';

export function UPCInfo({
  externalId,
  packageId,
}: {
  externalId: string;
  packageId: string;
}) {
  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(externalId);
  };

  return (
    <div
      className="flex items-center"
      onClick={(event) => {
        event.stopPropagation();
        handleCopyToClipboard();
      }}
      onKeyDown={(event) => {
        event.stopPropagation();

        if (event.key === 'Enter' || event.key === ' ') {
          handleCopyToClipboard();
        }
      }}
      role="button"
      tabIndex={0}
    >
      {externalId}
      <div className="group flex items-center" style={{ width: '3rem' }}>
        <div className="hidden pl-sm text-subtle hover:text-hover group-hover:block">
          <Icon type="copy" variant="light" size="sm" data-testid="copy-icon" />
        </div>
        <Tooltip content={packageId} side="top" delayDuration={0}>
          <Icon
            type="circle-info"
            variant="light"
            className="ml-sm text-subtle hover:text-hover"
            size="sm"
            data-testid="tooltip-icon"
          />
        </Tooltip>
      </div>
    </div>
  );
}

UPCInfo.displayName = 'UPCInfo';
